import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecureUrlPipe } from './secure-url';

@NgModule({
  declarations: [SecureUrlPipe],
  exports: [SecureUrlPipe],
  imports: [CommonModule],
})
export class SecureUrlModule {}
